import { apiClient } from "helpers/api_helper";
import { API } from "../constant/ecomSalesOrders.api";

export const getAllEcomSalesOrdersListData = async (data: object) => {
    try {
        const response = await apiClient.get(API.GET_ECOM_SALES_ORDER, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getAllEcomSalesOrdersItems = async (salesOrderId: any) => {
    try {
        const response = await apiClient.get(API.GET_ECOM_SALES_ORDER_ITEMS, salesOrderId);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const createPostOrder = async (data: object) => {
    try {
        const response = await apiClient.post(API.CREATE_CLICK_POST_ORDER, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getMakeToOrderItems = async (data: object) => {
    try {
        const response = await apiClient.get(API.Get_Make_To_Order_ItemBy_Sales_Order, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const assignProduct = async (data: object) => {
    try {
        const response = await apiClient.post(API.Add_Ecom_Make_To_Order_Product_In_Sales_Orders, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};